import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { UiIdService } from '../../services/ui-id.service';

@Component({
  selector: 'lib-labelled-checkbox',
  templateUrl: './labelled-checkbox.component.html',
  styleUrls: ['./labelled-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelledCheckboxComponent {
  @Input()
  id: string;

  @ContentChild(TemplateRef)
  templateRef!: TemplateRef<unknown>;

  constructor(private uiIdService: UiIdService) {
    this.id = `labelled_checkbox_${uiIdService.getNextId()}`;
  }
}
